import React from 'react';
import {ReactSVG} from 'react-svg'

const BGLayout = ({url}) => {
  return (
    <ReactSVG src={url} wrapper="svg" />
  );
}

export default BGLayout;